<script>
  let param;
  export const show = (params) => {
    param = params;
    style = 'display:block;';
  };
  export const hide = () => {
    style = 'display:none;';
    if (param.onHide != undefined) {
      param.onHide();
    }
  };
  let style = 'display:none;';
</script>

<div
  class="overlayModal"
  on:click={hide}
  style={style}
></div>
